module.exports = __webpack_public_path__ + "media/images/flags/64/Dominica-df8073cae5559f9f452fd2f48a455ae1.png";